/* Common Imports */
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import React, { useRef } from "react";

/* Component Imports */

import { Typography } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: "6rem 8rem 6rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 0rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 0rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 0rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 2rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 3rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 3rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 3rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 3rem 72rem",
    },
    margin: "4rem 0rem 6rem 0rem",
    [theme.breakpoints.down("sm")]: {
      margin: "3rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "100%",
      margin: "2.5rem 0rem 2.5rem 0rem",
    },
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
  categoryContent: {
    width: "100%",
    minHeight: "200px", // Set a minimum height to prevent layout shifting
    maxHeight: "400px",
    overflow: "auto", // Enable scrolling if content exceeds the height
    transition: "height 0.3s ease", // Smooth transition for height changes
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide on smaller screens
    },
  },
  illustrationSizer: {
    objectFit: "contain",
    width: "512px",
    height: "512px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  text: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "0.5rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  timeButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start", // Center-align buttons
    alignItems: "center",
    gap: "0.875rem",
    flexWrap: "wrap", // Allow wrapping to multiple lines
    width: "100%",
  },
  timeButton: {
    padding: "0.5rem 1rem",
    fontSize: "0.813rem",
    fontWeight: "500",
    color: "#693471",
    background: "#FFFFFF",
    border: "1px solid #693471",
    borderRadius: "0.5rem",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  activeTimeButton: {
    background: "#693471",
    color: "#FFFFFF",
  },
  ul: {
    fontSize: "1rem",
    paddingLeft: "1rem",
  },
  drawerContent: {
    padding: "1rem",
    [theme.breakpoints.down("sm")]: {
      padding: "1rem",
    },
  },
  drawerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center", // Align items vertically in the center
    [theme.breakpoints.down("sm")]: {
    //   marginBottom: "0.5rem",
      color: "#693471",
    },
  },
  closeButton: {
    color: "#666666",
  },
  drawerHeading: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      lineHeight: "1.5rem",
      textTransform: "uppercase",
      color: "#693471",
    },
  },
  li: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
}));
const SpecificationStaticSection = (props) => {
  const classes = useStyles();
  const [activeCategory, setActiveCategory] = React.useState("Electrical");
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const categoryRefs = useRef({});

  const categoryData = {
    Electrical: (
      <ul className={classes.ul}>
        <li className={classes.li}>TV point in living room, master bedroom, and guest bedroom</li>
        <li className={classes.li}>Electrical wires of Anchor or equivalent brand</li>
        <li className={classes.li}>Modular electrical switches of Anchor or equivalent brand</li>
        <li className={classes.li}>Earth Leakage Circuit Breaker (ELCB) for every flat</li>
        <li className={classes.li}>
          One Miniature Circuit Breaker (MCB) for each room provided at the main distribution box within each flat
        </li>
        <li className={classes.li}>Telephone points in the living room and all bedrooms</li>
        <li className={classes.li}>A/C Point for living room, master bedroom & guest bedroom</li>
        <li className={classes.li}>All flats will be provided with 5 KW power with energy meter</li>
        <li className={classes.li}>5 KVA dedicated power along with 15 Amp power sockets for tech workstations</li>
      </ul>
    ),
    Structure: (
      <ul className={classes.ul}>
        <li className={classes.li}>Seismic 2 - RCC Framed Structure</li>
        <li className={classes.li}>
          Concrete cement blocks of 6 inches for external walls and 4 inches for internal walls
        </li>
        <li className={classes.li}>Granite flooring in all lobbies and staircase</li>
      </ul>
    ),
    Lift: (
      <ul className={classes.ul}>
        <li className={classes.li}>Lift of 8 passenger capacity</li>
      </ul>
    ),
    Painting: (
      <ul>
        <li className={classes.li}>External walls with Asian Paint or equivalent brand</li>
        <li className={classes.li}>Internal walls and ceiling in Asian paint or equivalent brand</li>
        <li className={classes.li}>All MS railings in enamel paint</li>
      </ul>
    ),
    Floors: (
      <ul className={classes.ul}>
        <li className={classes.li}>Vitrified tiles in the foyer, living, dining and all bedrooms</li>
        <li className={classes.li}>Anti-skid tiles in Balconies</li>
      </ul>
    ),
    Toilet: (
      <ul className={classes.ul}>
        <li className={classes.li}>Anti-skid tiles for flooring</li>
        <li className={classes.li}>Vitrified tiles on walls up to false ceiling</li>
        <li className={classes.li}>Granite counter with wash basin in all toilets</li>
        <li className={classes.li}>Wall mounted EWCs from Kohler or equivalent brand</li>
        <li className={classes.li}>Chrome plated fittings from Kohler or equivalent brand</li>
        <li className={classes.li}>Concealed hot and cold wall mixers with hand shower</li>
        <li className={classes.li}>Sunken toilet slabs with extra protection layer</li>
        <li className={classes.li}>Glass partitions for shower enclosure</li>
      </ul>
    ),
    "Water supply": (
      <ul className={classes.ul}>
        <li className={classes.li}>Municipal water provision</li>
        <li className={classes.li}>Separate tanks for managing water supply</li>
        <li className={classes.li}>STP with recycled grey water connected to flush tanks and garden areas</li>
        <li className={classes.li}>Common pressure pump for high pressure water flow to all flats</li>
      </ul>
    ),
    Kitchen: (
      <ul className={classes.ul}>
        <li className={classes.li}>Vitrified tiles flooring</li>
        <li className={classes.li}>Provision for hot water in kitchen and utility</li>
        <li className={classes.li}>Kitchen countertop in 18-20 mm granite</li>
        <li className={classes.li}>Ceramic/Vitrified tile dado upto 2 feet over a granite counter</li>
        <li className={classes.li}>
          Single bowl with single drain steel sink, hot and cold mixer, and extendable tap in kitchen
        </li>
        <li className={classes.li}>Single bowl SS sink in utility with hot and cold mixer tap</li>
        <li className={classes.li}>Anti-skid vitrified tiles flooring and dadoing up to 4 feet in utility</li>
      </ul>
    ),
    Painting: (
      <ul className={classes.ul}>
        <li className={classes.li}>External walls with Asian Paint or equivalent brand</li>
        <li className={classes.li}>Internal walls and ceiling in Asian paint or equivalent brand</li>
        <li className={classes.li}>All MS railings in enamel paint</li>
      </ul>
    ),
    "Doors & Windows": (
      <ul className={classes.ul}>
        <li className={classes.li}>
          Main Door – Teak wood frame with factory made engineered wooden door shutters of 8 feet height with quality
          hinges, handles and security eye
        </li>
        <li className={classes.li}>Teak wood frame for main door with BST flush doors</li>
        <li className={classes.li}>Biometric lock with passcode entry access on main door</li>
        <li className={classes.li}>
          Other doors will be factory made engineered wooden door shutters of 8 feet height, with quality hinges, locks
          & handles
        </li>
        <li className={classes.li}>
          French Doors & Windows – Will be provided with 3 track Domal sliding doors/shutters with bug-mesh and clear
          glass bug-free mesh for balconies
        </li>
      </ul>
    ),
    "Backup & Generator": (
      <ul className={classes.ul}>
        <li className={classes.li}>
          1 KW Diesel Generator power backup for each apartment with automatic changeover switches
        </li>
        <li className={classes.li}>Separate lighting circuit for generator supply</li>
        <li className={classes.li}>Standby generator for lighting in common areas, lifts and pumps</li>
      </ul>
    ),
    Security: (
      <ul className={classes.ul}>
        <li className={classes.li}>Security room enabled with overview of building with CCTV access</li>
      </ul>
    ),
  };
  // Initialize refs for each category
  Object.keys(categoryData).forEach((category) => {
    if (!categoryRefs.current[category]) {
      categoryRefs.current[category] = React.createRef();
    }
  });

  const handleButtonClick = (category) => {
    setActiveCategory(category); // Update the active category
    if (isSmallScreen) {
      // Mobile: Open drawer and scroll to the category
      setDrawerOpen(true);
      setTimeout(() => {
        if (categoryRefs.current[category] && categoryRefs.current[category].current) {
          categoryRefs.current[category].current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    }
  };

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <img
            src="/images/icons/heavie/singleproperty/specification_static.webp"
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
            onClick={handleOpen} // Open dialog on click
            style={{ cursor: "pointer" }} // Add pointer cursor on hover
          />
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
          >
            <DialogContent>
              <img
                src="/images/icons/heavie/singleproperty/specification.webp"
                alt={AppConfig.imageAltText}
                width="100%"
                height="auto"
                loading="lazy"
                referrerPolicy="no-referrer"
              />
            </DialogContent>
          </Dialog>
          <div className={classes.text}>
            <Typography
              variant="h1"
              component="h1"
              className={classes.heading}
            >
              Specifications
            </Typography>
            <Typography
              variant="h6"
              component="span"
              className={classes.subHeading}
            >
              The specification and materials used for Heavie Eden have be carefully planned to balance functionality,
              aesthetics and sustainability. We are constantly working on using the best products and incorporating the
              latest construction processes to improve your home experience.
            </Typography>
            {/* Buttons for Categories */}
            <div className={classes.timeButtons}>
              {Object.keys(categoryData).map((category) => (
                <button
                  key={category}
                  className={`${classes.timeButton} ${activeCategory === category ? classes.activeTimeButton : ""}`}
                  onClick={() => handleButtonClick(category)}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Display Data for Active Category */}
            <div className={classes.categoryContent}>
              {typeof categoryData[activeCategory] === "string" ? (
                <Typography
                  variant="body1"
                  component="p"
                >
                  {categoryData[activeCategory]}
                </Typography>
              ) : (
                categoryData[activeCategory]
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Drawer for Mobile */}
      {isSmallScreen && (
        <SwipeableDrawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onOpen={() => setDrawerOpen(true)}
          PaperProps={{
            style: { borderRadius: "1rem 1rem 0rem 0rem", height: "60vh" },
          }}
        >
          <div
            className={classes.drawerContent}
            style={{
              overflowY: "auto",
              height: "100%",
            }}
          >
            {/* Drawer Header */}
            <div
              className={classes.drawerHeader}
              style={{
                position: "sticky",
                top: -16,
                backgroundColor: "#fff",
                zIndex: 10,
                padding: "0.5rem 0rem 0.5rem 0rem",
              }}
            >
              <Typography
                variant="h6"
                component="h2"
                style={{
                  fontWeight: 600,
                  fontSize: "1.25rem",
                  color: "#212121",
                }}
              >
                Specifications
              </Typography>
              <IconButton
                onClick={() => setDrawerOpen(false)}
                className={classes.closeButton}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
            {/* Drawer Content */}
            <div>
              {Object.keys(categoryData).map((category) => (
                <div
                  key={category}
                  ref={categoryRefs.current[category]}
                  style={{ margin: "1rem 0rem 1rem 0rem", zIndex: 0 }}
                >
                  <Typography
                    variant="h6"
                    component="h3"
                    className={classes.drawerHeading}
                  >
                    {category}
                  </Typography>
                  {categoryData[category]}
                </div>
              ))}
            </div>
          </div>
        </SwipeableDrawer>
      )}
    </React.Fragment>
  );
};
export default SpecificationStaticSection;
